import { HttpApiClient } from "api/httpApiClient"
import { LoginApiClient, LoginRequest, LoginResponse } from "api/index"

export class LoginApiClientImpl implements LoginApiClient {
  constructor(private readonly client: HttpApiClient = new HttpApiClient()) {}
  async postLogin(request: LoginRequest): Promise<LoginResponse> {
    return await this.client.post<LoginResponse>("/api/v1/login", request).then((response) => response.data)
  }
}
